import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Workflow, WorkflowItem, WorkflowService, WorkflowType} from '../../../interfaces/engin/workflow';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {APIResponse} from '../../../interfaces/system/system-common';
import {WorkflowApi} from '../api/workflow.api';
import {SnapshotDto} from '../../../interfaces/common/snapshot';
import {PagingResponse} from '../../../interfaces/system/system-common';

@Injectable()
export class WorkflowServiceImpl extends WorkflowService {
    constructor(private api: WorkflowApi) {
        super();
    }

    getWorkflowDataSource(type: WorkflowType): Observable<DataSource> {
        return this.api.getWorkflowDataSource(type);
    }

    getWorkflowById(workflowId: number): Observable<APIResponse<Workflow>> {
        return this.api.getWorkflowById(workflowId);
    }

    getWorkflowItemById(workflowItemId: number): Observable<APIResponse<WorkflowItem>> {
        return this.api.getWorkflowItemById(workflowItemId);
    }

    getLatestCompletedWorkFlow(isTrue: boolean): Observable<APIResponse<Workflow>> {
        return this.api.getLatestCompletedWorkFlow();
    }

    executeNewWorkflowFromSnapshot(
        snapshotId: number,
        workflowType: string,
        automated: boolean,
        date?: string,
    ): Observable<any> {
        return this.api.executeNewWorkflowFromSnapshot(snapshotId, workflowType, automated, date);
    }

    // executeNewWorkflowFromSnapshot(snapshotId: number, automated: boolean, date?: string): Observable<any> {
    //     return this.api.executeNewWorkflowFromSnapshot(snapshotId, automated, date);
    // }

    updateWorkflowNoteTag(workflowId: number, workflow: Workflow): Observable<APIResponse<Workflow>> {
        return this.api.updateWorkflowNoteTag(workflowId, workflow);
    }

    findBySnapshotId(snapshotId: number): Observable<APIResponse<Workflow>> {
        return this.api.findBySnapshotId(snapshotId);
    }

    delete(workflowId: number): Observable<APIResponse<boolean>> {
        return this.api.delete(workflowId);
    }

    reversePendingDelete(workflowId: number): Observable<APIResponse<boolean>> {
        return this.api.reversePendingDelete(workflowId);
    }

    updateActiveWorkflow(workflowId: number, userId: string, active: boolean): Observable<APIResponse<boolean>> {
        return this.api.updateActiveWorkflow(workflowId, userId, active);
    }

    findBySnapshotDtoByWorkflowId(workflowId: number): Observable<APIResponse<SnapshotDto>> {
        return this.api.findBySnapshotDtoByWorkflowId(workflowId);
    }

    findAllBySnapshotId(snapshotId: number): Observable<APIResponse<Workflow[]>> {
        return this.api.findAllBySnapshotId(snapshotId);
    }

    listLatestWorkflows(pageSize: number, workflowType: string): Observable<PagingResponse<Workflow>> {
        return this.api.listLatestWorkflows(pageSize, workflowType);
    }
}
